import React, { useContext } from 'react';
import getNavItems from './util/NavItems';
import './SideBar.css'
import { NavLink, useLocation } from 'react-router-dom';
import DashboardContext from '../../context/dashboardContext';

const SideBar = () => {
    const dashContext = useContext(DashboardContext);
    const counts = [
        dashContext.areaCount,
        dashContext.orders2Count,
        dashContext.productCategoryCount,
        dashContext.productCount,
        '',
        dashContext.jobCategoryCount,
        dashContext.personsCount,
        '',
        dashContext.placeCategoryCount,
        dashContext.placeCount,
        '',
        dashContext.ordersCount,
        '',
        dashContext.usersCount,
        dashContext.commentsCount,
        dashContext.viewersCount,
    ]
    const navItems = getNavItems();
    const { pathname } = useLocation()
    return (
        <div>
            <nav>
                <ul className="list-group pr-0 mr-lg-4 mr-xl-2 bg-white">
                    {
                        navItems.map((item, index) =>
                            <li key={index} className={pathname === item.link ? "list-group-item active" : "list-group-item"}>
                                <NavLink to={item.link} className="d-flex justify-content-between align-items-center">
                                    <span>
                                        <i className={`${item.iconClassName} mr-2 text-muted`}></i>
                                        {item.name}
                                    </span>
                                    <span className="badge badge-success badge-pill">{counts[index]}</span>
                                </NavLink>
                            </li>
                        )
                    }
                </ul>
            </nav>
        </div>
    );
}

export default SideBar;